import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(public http: HttpClient) { }

  addLeadSquared(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }


  updateLeadSquared(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  addCRMLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": reqData.orgId,
        "uid":  reqData.uid,
      })
    };

      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  callbackLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
       "orgid": reqData.orgId,
        "uid":  reqData.uid,
      })
    };

      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create/backup', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  callback(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post('https://api-prod.iquanta.in/adminapp/call_back/', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  saveUserLEadForm(reqData:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };
  
    return this.http.post('https://itech-api-prod.iquanta.in/api/mbr/home/v1/sent/enquiry', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  updateUserLeadForm(reqData:any, id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };
  
    return this.http.patch('https://itech-api-prod.iquanta.in/api/mbr/home/v1/update/'+id, reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

}